'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactAddController = function () {
    /* @ngInject */
    function ContactAddController($scope, $state, $stateParams, $ionicPopup, $ionicLoading, ApiInvestors, ApiCampaigns, ApiPicklist, ApiTeam, $rootScope) {
        _classCallCheck(this, ContactAddController);

        this.ApiInvestors = ApiInvestors;
        this.ApiPicklist = ApiPicklist;
        this.ApiTeam = ApiTeam;
        this.$state = $state;
        this.$ionicLoading = $ionicLoading;
        this.$stateParams = $stateParams;
        this.$ionicPopup = $ionicPopup;
        this.$rootScope = $rootScope;

        // Prerequisites
        this.investor = {};

        this.investorId = $stateParams.investorId;
        this.isCustomerInvestor = false;
        this.editMode = false; // flag true if new entry
        this.createInvestor = false;
        this.translationVisible = false;
        this.advindaCount = this.$stateParams.advindaCount;
        this.customCount = this.$stateParams.customCount;

        this.cleaveNumeral = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand'
        };
    }

    _createClass(ContactAddController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
                duration: 10000
            });
            this.$rootScope.pageTitle = 'CREATE_ACCOUNT';

            /**
             * Checking if edit mode
             */
            if (this.$stateParams.investorId) {
                this.editMode = true; // enable the edit flag
                this.$rootScope.pageTitle = 'EDIT_INVESTOR_ACCOUNT';

                // Load contact from database
                this.ApiInvestors.getInvestor(this.investorId, { 'isCustomerAccount': true }).then(function (res) {
                    if (typeof res != 'undefined') {
                        _this.investor = res.investor;
                        _this.$ionicLoading.hide();
                    } else {
                        _this.$ionicLoading.hide();
                    }
                });
            } else {
                this.$ionicLoading.hide();
            }

            this.ApiPicklist.getInvestorTypes().then(function (investorTypes) {
                _this.investorTypes = investorTypes.data.map(function (investorType) {
                    return investorType.type;
                });
            });

            this.ApiPicklist.getAdvindaCountries().then(function (advindaCountries) {
                _this.advindaCountries = advindaCountries.data;
                _this.advindaCountries.unshift("");
            });

            this.getTeams();
        }
    }, {
        key: 'saveInvestor',
        value: function saveInvestor() {
            var _this2 = this;

            // edit campaign
            if (this.editMode) {
                this.ApiInvestors.putInvestor(this.investor).then(function (res) {
                    if (res) {
                        _this2.$state.go('investors', {}, { reload: true });
                    }
                });
            } else {
                this.ApiInvestors.postInvestor(this.investor).then(function (res) {
                    if (res) {
                        _this2.$state.go('investors', {}, { reload: true });
                    }
                });
            }
        }
    }, {
        key: 'getTeams',
        value: function getTeams() {
            var _this3 = this;

            this.ApiTeam.getTeams().then(function (res) {
                if (typeof res != 'undefined') {
                    if (res) {
                        _this3.translationVisible = res.translationRequired;
                    }
                }
            });
        }
    }]);

    return ContactAddController;
}();

exports.default = ContactAddController;


/** WEBPACK FOOTER **
 ** ./src/app/components/investors/investorAdd.controller.js
 **/